import React from "react";
import { ErrorNotification } from "store/errors/types";
import styles from "./ErrorVideoCover.module.css";

interface ErrorVideoCoverProps {
  /** The notification. */
  error: ErrorNotification;
}

/** An error alert. */
export const ErrorVideoCover: React.FC<ErrorVideoCoverProps> = ({
  error
}: ErrorVideoCoverProps) => {

  const getErrorText = (errorName: string) => {
    switch (errorName) {
      case "NotFoundError":
        return "Make sure that the camera and microphone you have selected are available and enabled."
      case "NotReadableError":
        return "Make sure that your camera and microphone are not being used by another app or browser tab right now."
      case "NotAllowedError":
        return "Make sure that you have not blocked this website from using your camera and microphone."
      default:
        return "There was a problem acquiring your camera or microphone."
    }
  }

  return (
    <>
      <div className={styles["error-video-cover"]}>
        <p>{error.name}</p>
        <p>{getErrorText(error.name)}</p>
      </div>
    </>
  );
};
